import { useLocation } from "wouter";
import { useCallback } from "react";

export interface StoryRedirectOptions {
  storyId: number;
  fromWizard?: boolean;
  playAudio?: boolean;
}

export function useStoryRedirect() {
  const [, setLocation] = useLocation();

  const redirectToStory = useCallback((options: StoryRedirectOptions) => {
    const { storyId, fromWizard = false, playAudio = false } = options;
    
    // Defensive check: prevent navigation with invalid storyId
    if (!Number.isInteger(storyId) || storyId <= 0) {
      console.error('Invalid storyId passed to redirectToStory:', storyId);
      console.trace(); // Log stack trace to identify the caller
      return; // Don't navigate with invalid ID
    }
    
    // Build the story URL with appropriate query params
    let url = `/story/${storyId}`;
    const params = new URLSearchParams();
    
    if (fromWizard) {
      params.set('from', 'wizard');
    }
    
    if (playAudio) {
      params.set('autoplay', 'true');
    }
    
    if (params.toString()) {
      url += `?${params.toString()}`;
    }
    
    // Navigate to the story page
    setLocation(url);
  }, [setLocation]);

  const redirectToStories = useCallback(() => {
    setLocation('/stories');
  }, [setLocation]);

  const redirectToHome = useCallback(() => {
    setLocation('/');
  }, [setLocation]);

  return {
    redirectToStory,
    redirectToStories,
    redirectToHome
  };
}